import { Colors } from "../constants/colors"
import { ReactNode } from "react"

interface ScreenProps {
    children: ReactNode;
    backgroundColor?: string;
}

export const Screen = ({
    children,
    backgroundColor = Colors.white
}: ScreenProps) => {
    const styles = {
        container: {
            flex: 1,
            backgroundColor: backgroundColor,
            width: "100%"
        }
    }

    return (
        <div style={styles.container}>
            {children}
        </div>
    );
}